import type { AppConfig } from 'nuxt/schema'
import loadScriptAsync from '../loadScriptAsync'
import debug from '../console'
const logger = debug.withTag('utils:preAYScripts')

export const preAYScripts = async (config: AppConfig['adops']) => {
  const { boltive } = config

  /**
   * Kicked off before the other two rather than awaited behind them. Launchpad carries
   * the CMP, and LiveRamp is explicit that the CMP has to be up before ATS and the
   * consent-gated calls that depend on it. Awaiting it third meant it did not begin
   * fetching until two unrelated scripts had fully loaded. It is still awaited at the
   * end, so this function keeps resolving only once every pre-AY script has settled.
   */
  const liveramp = loadScriptAsync(
    'head',
    {
      src: `https://launchpad-wrapper.privacymanager.io/528606c5-a8ba-42f7-be55-93209da0477d/launchpad-liveramp.js`,
      key: 'liveramp',
    },
    { defer: true }
  ).catch((error) => {
    logger.warn(
      'Failed to load LiveRamp identity module, continuing without enhanced targeting',
      error
    )
  })

  if (boltive.scriptUrl) {
    try {
      await loadScriptAsync('head', {
        src: boltive.scriptUrl,
        key: 'boltive',
      })
    } catch (error) {
      logger.warn(
        'Failed to load Boltive script, continuing without ad fraud protection',
        error
      )
    }
  }

  // load gamera - tracks ads per minute, ad density etc
  try {
    await loadScriptAsync('head', {
      src: `https://metrics.rapidedge.io/gamera.js?ltv=1&audience=1&tpcs=1&partner=duplex`,
      key: '__gamera__',
    })
  } catch (error) {
    logger.warn(
      'Failed to load Gamera analytics script, continuing without ad metrics',
      error
    )
  }

  await liveramp
}
